import { readPref } from './storage'

const enabled = readPref('debug') === '1'

/** Console logging that is off unless localStorage `moot:debug` is "1". */
export function dbg(...args: unknown[]) {
  if (enabled) console.debug('[moot]', ...args)
}
